// extracted by mini-css-extract-plugin
module.exports = {"objectiveContainer":"styles_objectiveContainer__HMX8k","title":"styles_title__BOv7J","content":"styles_content__HgUmh","highlight":"styles_highlight__A_rNb"};